__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/7adc3110232e1e36c0e94436fe6049e476b4abe2/_next/";